import type { Principle } from '../types/content';

export const boardConsiderations: Principle[] = [
  {
    title: 'Board composition',
    description:
      'We start from the board’s current skills, experience and perspectives, and the gaps the appointment is intended to address.',
  },
  {
    title: 'Independence and conflicts',
    description:
      'Potential candidates are considered in light of independence requirements and any actual or perceived conflicts of interest.',
  },
  {
    title: 'Time commitment',
    description:
      'We discuss realistic time expectations, existing commitments and capacity openly with potential candidates.',
  },
  {
    title: 'Committee requirements',
    description:
      'Where a role involves committee membership or chairing, relevant experience is defined and assessed explicitly.',
  },
];

export const boardDifferences = [
  {
    title: 'Different stakeholders',
    text: 'Board searches typically involve the chair, a nominations committee and sometimes shareholders. We structure communication around each.',
  },
  {
    title: 'Different criteria',
    text: 'Governance judgement, constructive challenge and complementarity with the existing board matter as much as executive track record.',
  },
  {
    title: 'Greater sensitivity',
    text: 'Board changes are often confidential until announced. Discretion is built into every stage of outreach and reporting.',
  },
];
